<template>
  <!-- <div
    class="quality-control-report-box h-full box-border"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    v-loading.lock="loadingContainer"
  > -->
  <!-- v-if="!loadingContainer" -->
  <div class="bigbox">
    <!-- //第二个页面 -->
    <div v-if="type === 1">
      <div class="sevenbox" ref="child">
        <el-col>
          <el-cascader
            v-model="form.channel"
            :options="channelOptions"
            @change="qdsChange"
            placeholder="回收渠道"
            clearable
            size="small"
          ></el-cascader>
        </el-col>
        <el-col>
          <el-select
            v-model="form.answerChannelId"
            placeholder="子渠道"
            clearable
            :disabled="channelsListOptions.length === 0"
            size="small"
            @change="commonChange"
          >
            <el-option
              v-for="(item, index) in channelsListOptions"
              :key="index"
              :label="item.channel_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <div class="block">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width: 235px"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
          >
          </el-date-picker>
        </div>
        <el-input v-model="inputa" placeholder="知情同意书ID" clearable></el-input>
        <el-input v-model="inputb" placeholder="答卷ID" clearable></el-input>
        <el-button type="primary" @click="queryUsers">查询</el-button>
        <el-button type="primary" plain @click="reset">重置</el-button>
      </div>
      <!-- 表格 -->
      <div class="tables">
        <el-table
          ref="multipleTable"
          v-loading="tableLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          max-height="500"
        >
          <el-table-column type="selection" width="40" align="right"> </el-table-column>
          <el-table-column prop="id" label="知情同意书" width="200"> </el-table-column>
          <el-table-column label="用户ID">
            <template slot-scope="scope">
              {{ scope.row.accountUserInfo.split(':')[1] }}
            </template></el-table-column
          >
          <el-table-column prop="accountUserWxNickname" label="微信昵称"> </el-table-column>
          <el-table-column prop="ipAddress" label="IP地址" width="160"> </el-table-column>
          <el-table-column prop="channel" label="回收渠道"
            ><template slot-scope="{ row }">
              <span>{{ channelOptions[row.channel].label }}</span>
            </template></el-table-column
          >
          <el-table-column prop="answerChannel" label="子渠道"> </el-table-column>
          <el-table-column prop="relatedAnswerIds" label="关联答卷ID" width="150">
            <template slot-scope="scope">
              <div v-for="item in scope.row.relatedAnswerIds.split(',')" :key="item">
                {{ item }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="提交时间" width="150"> </el-table-column>
          <el-table-column label="操作" fixed="right" width="100">
            <template slot-scope="scope">
              <div class="fus">
                <div class="down" @click="handleEdit(scope.row)">下载</div>
                <el-popconfirm
                  confirm-button-text="确认"
                  cancel-button-text="取消"
                  icon-color="#626AEF"
                  title="确认删除?"
                  @confirm="confirmEvent(scope.row)"
                  @cancel="cancelEvent"
                >
                  <template #reference>
                    <div>删除</div>
                  </template>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 底部 -->
        <div class="botbox">
          <el-checkbox class="botleft" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
            >已选择<span>{{ select }}</span
            >项</el-checkbox
          >
          <el-checkbox class="botlefts" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
            >选择全部</el-checkbox
          >

          <el-popconfirm
            confirm-button-text="确认"
            cancel-button-text="取消"
            icon-color="#626AEF"
            title="确认删除?"
            @confirm="handleDeletes"
            @cancel="cancelEvent"
          >
            <template #reference>
              <el-button class="more" type="danger">批量删除</el-button>
            </template>
          </el-popconfirm>
          <el-button class="more" type="primary" @click="downs">批量下载</el-button>
        </div>
          <div class="paging">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
      </div>
    </div>
    <div v-else-if="type===2">
      <div class="dis">
        <div class="topbox">
          <h1 class="topboxh">知情同意书</h1>
        </div>
      </div>
      <div class="dis">
        <div class="alist">
          您还未添加知情同意书题型，<a class="acolor" href="#" @click="dialogVisible = true">添加知情同意书教程</a>
        </div>
      </div>
      <div class="dis">
        <div class="upgrade">
          <a :href="getBaseDomain()+'/version-pricing.html'">升级版本</a>
          <div class="upgradefu">86% 用户已升级</div>
        </div>
      </div>
      <div class="dis">
        <div class="times">您的企业版已于 {{ times }} 过期</div>
      </div>
      <div class="dis">
        <div class="bottombox">
          <div class="tops">
            <!-- 截图 -->
            <div class="phones">
              <div class="sizes">知情同意书：用户需阅读并接受后方可答题，知情同意书内容支持自定义</div>
              <div class="sizes">知情同意书对比单选题甄别的优势</div>
              <div class="sizes">1. 回收的知情同意书与答卷 分开保存，数据隔离，保障用户隐私；</div>
              <div class="sizes">2. 开展连续多期调查时，可设置同一用户多次答题仅需签署一份知情同意书。</div>
              <div class="bottbox">
                <img class="bottboxs" src="@/assets/img/informed-consent/addin.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <el-dialog title="添加知情同意书说明" :visible.sync="dialogVisible" width="1130px">
        <span slot="footer" class="dialog-footer">
          <img class="phonesdia" src="@/assets/img/informed-consent/addinfor.png" alt="" />
        </span>
      </el-dialog>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import {
  getInformedConsentConfigH,
  batchExports,
  batchRemoves,
  exportsa,
  pageList,
  queryUser
} from '@/api/wenjuan/informed-consent'
import { subChannel } from '@/api/wenjuan/answerList'
import { getUserScope } from '@/api/auth'
import { getBaseDomain } from '@/assets/js/config/env'
import GlobalConfig, { AuthConfig } from '@/global/config'
export default {
  data() {
    return {
      tableLoading: false,
      onebox: false,
      twobox: true,
      value1: '',
      dialogVisible: false,
      posterDataURL: '', // 初始化海报数据URL
      form: {
        channel: '',
        answerChannelId: ''
      },
      channelOptions: [
        {
          value: '0',
          label: '网络调查'
        },
        {
          value: '2',
          label: '面对面访问'
        },
        {
          value: '3',
          label: '样本-后台添加'
        },
        {
          value: '4',
          label: '样本-邀请添加'
        },
        {
          value: '5',
          label: '短信发送'
        },
        {
          value: '7',
          label: '电话访问'
        },
        {
          value: '8',
          label: '样本导入'
        },
        {
          value: '9',
          label: '委托代理'
        },
        {
          value: '10',
          label: '样本库推送'
        },
        {
          value: '12',
          label: '样本服务',
          children: []
        },
        {
          value: '17',
          label: '定向发布（企业员工）'
        },
        {
          value: '18',
          label: '定向发布（外部组织）'
        }
      ],
      channelsListOptions: [], // 子渠道options
      tableData: [],
      checkAll: false,
      isIndeterminate: false,
      currentPage: 4,
      lineWidth: 6,
      lineColor: '#000000',
      bgColor: '',
      resultImg: '',
      isCrop: false,
      select: 0,
      size: 10,
      total: 30,
      inputa: '',
      inputb: '',
      Changea: '',
      Changeb: '',
      listtabe: [],
      times: '',
      channels: 0,
      pages: {
        current: 1,
        size: 10,
        surveyId: GlobalConfig.getSurveyId()
      },
      loadingContainer: true,
      listid: '',
      // 默认为0  1为显示表格 2为显示升级
      type:0
    }
  },
  created() {
    // getInformedConsentConfigH({ surveyId: GlobalConfig.getSurveyId() }).then(res => {
    //   if (res.data.data) {
    //     this.isShowTable = true
    //   }
    // })
    this.lists()
  },
  mounted() {
    this.timeout()
  },
  methods: {
    confirmEvent(value) {
      let selectedIds = [value.id]
      batchRemoves({ selectedIds: selectedIds }).then(res => {
        console.log(res)
        if (res.data.data) {
          this.$message({
            message: res.data.msg,
            type: 'success'
          })
          this.lists()
          this.checkAll = false
        }
      })
    },
    cancelEvent() {
      console.log('cancel!')
    },
    downs() {
      // let selectedIds = []
      // if (this.listtabe.length > 0) {
      //   this.listtabe.forEach(item => {
      //     selectedIds.push(item.id)
      //   })
      console.log(this.tableData, 7777)

      console.log(this.listid, 6666)
      let query = { channel: this.channels, surveyId: GlobalConfig.getSurveyId() }
      batchExports({ query: query, fileType: 'pdf', selectedIds: this.listid }).then(res => {
        console.log(res, '批量下载')
        const pdfUrl = res.data.data
        if (res.data.msg == '未找到数据') {
          this.$message({
            message: '未找到数据',
            type: 'info'
          })
          this.listid = []
        } else {
          window.open(pdfUrl)
          this.listid = []
        }
      })
      // }else{
      //   this.$message({
      //     message: '请先选择下载内容',
      //     type: 'info'
      //   })
      // }
    },
    timeout() {
      getUserScope().then(res => {
        this.times = res.data.data.expirationTime
        this.setType()
      })
    },
    setType() {
      const authCode = GlobalConfig.getAuthCode()
      const targetTimestamp = new Date(this.times).getTime(); 
      const currentTimestamp = Date.now();
      const isExpired = targetTimestamp > currentTimestamp;
      if((authCode === AuthConfig.TeamBase || authCode === AuthConfig.TeamPlus) && isExpired) {
        this.type = 1
      }else {
        this.type = 2
      }
    },
    handleDeletes() {
      let selectedIds = []
      this.listtabe.forEach(item => {
        selectedIds.push(item.id)
      })
      if (selectedIds.length == 0) {
        this.$message({
          message: '删除失败',
          type: 'error'
        })
        this.checkAll = false
      } else {
        batchRemoves({ selectedIds: selectedIds }).then(res => {
          this.$message({
            message: res.data.msg,
            type: 'success'
          })
          this.lists()
          this.checkAll = false
        })
      }
    },
    commonChange(value, va) {
      const selectedChannel = this.channelsListOptions.find(option => option.id == value)
      if (selectedChannel) {
        this.Changeb = selectedChannel.channel_name
      }
    },
    qdsChange(v) {
      const selectedChannel = this.channelOptions.find(option => option.value == v)
      if (selectedChannel) {
        this.Changea = selectedChannel.value
      }
      // 清空子渠道
      this.form.answerChannelId = ''
      this.channelsListOptions = []
      // this.$refs.child.getTableData()
      if (!v || v.length === 0 || v.length === 2) return
      let channel = v[v.length - 1]
      subChannel(channel, this.$route.params.id)
        .then(res => {
          this.channelsListOptions = (res.data && res.data.data) || []
        })
        .catch(err => {
          console.log(err)
        })
    },
    queryUsers() {
      let list = {
        channel: this.Changea,
        answerChannel: this.Changeb,
        createTimeGe: this.value1[0],
        createTimeLt: this.value1[1],
        signId: this.inputa,
        size: this.pages.size,
        surveyId: GlobalConfig.getSurveyId(),
        current: this.pages.current,
        relatedAnswerId: this.inputb
      }
      pageList(list).then(res => {
        console.log(res, 77788)
        let ids = []
        res.data.data.records.forEach(item => {
          ids.push(item.id)
        })
        this.listid = ids
        this.tableData = res.data.data.records
        this.size = res.data.data.size
        this.total = res.data.data.total
        this.sortDataByUpdateTime() // 调用排序方法
        this.$message({
          message: '查询成功',
          type: 'success'
        })
        this.channels = res.data.data.records[0].channel
        this.Changeb = ''
        this.Changea = ''
      })
    },
    reset() {
      this.value1 = ''
      this.channelsListOptions = []
      this.inputa = ''
      this.inputb = ''
      this.form.channel = ''
      this.form.answerChannelId = ''
      this.Changeb = ''
      this.lists()
    },
    //下载
    handleEdit(val) {
      exportsa({ signId: val.id, fileType: 'pdf' })
        .then(res => {
          console.log(res, '导出下载')
          const pdfUrl = res.data.data
          window.open(pdfUrl)
        })
        .catch(error => {
          console.error('导出下载失败', error)
        })
    },
    lists() {
      this.tableLoading = true
      pageList(this.pages).then(res => {
        this.tableData = res.data.data.records
        this.size = res.data.data.size
        this.total = res.data.data.total
        this.sortDataByUpdateTime() // 调用排序方法
        this.tableLoading = false
        // this.loadingContainer = false
      })
    },
    // 根据提交时间排序数据
    sortDataByUpdateTime() {
      let timslist = []
      timslist = [...this.tableData] // 复制原始数据
      // 根据 updateTime 属性进行降序排序
      timslist.sort((a, b) => new Date(b.updateTime) - new Date(a.updateTime))
      this.tableData = timslist
    },
    handleReset() {
      this.$refs.esign.reset()
    },

    handleSelectionChange(selection) {
      console.log(selection, 555555)
      let ids = []
      selection.forEach(item => {
        ids.push(item.id)
      })
      this.listid = ids
      this.listtabe = selection
      this.isIndeterminate = selection.length > 0 && selection.length < this.tableData.length
      this.checkAll = selection.length === this.tableData.length
      this.select = selection.length
    },
    handleCheckAllChange(val) {
      this.checkAll = val
      this.tableData.forEach(item => {
        this.$refs.multipleTable.toggleRowSelection(item, val)
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pages.size = val
      this.lists()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.pages.current = val
      this.lists()
    }
  },
}
</script>
<style lang="scss" scoped>

::v-deep .el-table th.el-table__cell>.cell{
  font-size: 14px;
}
::v-deep .el-table__body, .el-table__footer, .el-table__header{
  font-size: 14px;
}
::v-deep .el-dialog__body {
  padding: 0px;
}
.tables {
  position: relative;
  height: 70vh;
  margin-left: 16px;
  margin-right: 16px;
  padding-bottom: 30px;
}
.phonesdia {
  width: 1091px;
  height: 620px;
  margin: auto;
}
.block {
  margin-left: -5px;
}
.el-col-24 {
  width: 188px;
}
.el-col {
  margin-right: 16px;
}
.img_case {
  width: 300px;
  height: 300px;
}
.down {
  margin-right: 16px;
}
.paging {
  position: absolute;
  bottom: 0px;
  right: 16px;
}
.botleft {
  margin-left: 25px;
  width: 110px;
}
.botlefts {
  margin-left: -20px;
}
.el-checkbox {
  margin-top: 21px;
}
.more {
  width: 88px;
  margin-top: 14px;
}
.botbox {
  position: absolute;
  bottom: 0px;
  left: 0px;
  // position: relative;
  display: flex;
}
.fus {
  display: flex;
  font-size: 14px;
  color: #2775e8;
  cursor: pointer;
}
.el-button {
  height: 32px;
  margin-left: 12px;
  font-size: 14px;
}
.el-input {
  width: 188px;
  height: 32px;
  margin-left: 12px;
}
.el-cascader {
  width: 188px;
  height: 32px;
  margin-right: 12px;
}
.sevenbox {
  display: flex;
  padding-top: 16px;
  margin-left: 15px;
}
////////////////////////////第一个盒子
.boxs {
  width: 100%;
  height: 290px;
  overflow: auto;
}
.butts {
  display: flex;
  position: absolute;
  bottom: 10px;
  right: 16px;
}
.buttsa {
  width: 110px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  border-radius: 2px;
  font-size: 10px;
  cursor: pointer;
  background: #f5f5f5;
  margin-right: 10px;
  color: #a6a6a7;
}
.buttsb {
  width: 110px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  border-radius: 2px;
  font-size: 10px;
  cursor: pointer;
  background: #2775e8;
  color: #fff;
}
.signature {
  width: calc(100% - 16px);
  height: 100px;
  border: 1px dashed #000;
}
.twobox {
  position: relative;
  font-size: 12px;
  cursor: pointer;
}
.twos {
  position: absolute;
  top: 0px;
  right: 10px;
  display: flex;
  color: #84b1f2;
}
.el-icon-refresh-right {
  margin-top: 1px;
  font-weight: bold;
  margin-right: 2px;
}
.bottsize {
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: bold;
}
.xianbox {
  width: calc(100% - 16px);
  height: 1px;
  background: #ececec;
  margin: 10px 0;
}
.fsizes {
  font-size: 9px;
  line-height: 16px;
}
.fsize {
  font-size: 9px;
  line-height: 16px;
  font-weight: 600;
}
.fffbox {
  position: relative;
  width: calc(100% - 32px);
  height: 348px;
  background: #fff;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 16px;
  overflow: auto;
}
.zhitop {
  margin: 10px 0 10px 16px;
  font-size: 15px;
}
.bottboxs {
  width: 512px;
  height: 370px;
}
.bottbox {
  width: 512px;
  height: 370px;
  border: 1px solid #e1e5eb;
  border-radius: 2px;
  margin-top: 16px;
}
.sizes {
  height: 22px;
  opacity: 0.85;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  text-align: left;
  line-height: 22px;
}
.bottombox {
  width: 560px;
  height: 534px;
  background: #fff;
  border-radius: 2px 2px 2px 0 2px;
  border-radius: 2px 2px 2px 0 2px;
  margin: 0 auto;
}
.tops {
  margin-top: 16px;
  margin-left: 24px;
}
.times {
  width: 280px;
  height: 22px;
  font-weight: 500;
  font-size: 14px;
  color: #e8a31b;
  text-align: left;
  line-height: 22px;
  margin: 0 auto;
  margin-bottom: 23px;
}
.upgrade {
  position: relative;
  margin: 0 auto;
  width: 128px;
  height: 32px;
  background: #fec08e;
  border-radius: 2px;
  text-align: center;
  line-height: 32px;
  margin-bottom: 16px;
  font-weight: 400;
  font-size: 14px;
  color: #6b4d3b;
  cursor: pointer;
}
.upgradefu {
  position: absolute;
  top: -10px;
  right: -50px;
  width: 84px;
  height: 18px;
  background: #e34152;
  border-radius: 2px;
  text-align: center;
  line-height: 18px;
  cursor: pointer;
  font-weight: 600;
  font-size: 10px;
  color: #ffffff;
}
.alist {
  margin: 0 auto;
  color: #000000;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0;
  margin-bottom: 24px;
}
.acolor {
  color: #2775e8;
}
.topbox {
  margin: 0 auto;
  margin-top: 39px;
  margin-bottom: 20px;
}
.topboxh {
  opacity: 0.85;
  font-weight: 500;
  font-size: 20px;
  color: #000000;
  line-height: 22px;
}
.dis {
  display: flex;
}
.bigbox {
  width: calc(100% - 32px);
  background: #fff;
  box-shadow: 0 1px 4px 0 #0000000f;
  border-radius: 2px;
  margin: 16px;
  padding-bottom: 16px;
  position: relative;
}
</style>
